import { Button, Card, CardContent } from '@tark/shared/components';
import type { TenantTimePoll } from '@tark/shared/types';
import { ArrowRight, CalendarClock, Plus } from 'lucide-react';

type Props = {
  polls: TenantTimePoll[];
  onCreate: () => void;
  onOpen: (poll: TenantTimePoll) => void;
};

const statusStyle: Record<TenantTimePoll['status'], string> = {
  DRAFT: 'border-border bg-surface-elevated text-text-muted',
  OPEN: 'border-primary/30 bg-primary/10 text-primary',
  CLOSED: 'border-border bg-surface text-text-muted',
};

export default function CoachTimePollList({ polls, onCreate, onOpen }: Props) {
  if (polls.length === 0) {
    return (
      <Card variant="default">
        <CardContent className="flex flex-col items-start gap-4 py-8">
          <span className="rounded-lg bg-primary/10 p-3 text-primary"><CalendarClock className="h-5 w-5" /></span>
          <div>
            <p className="font-semibold text-text">No time polls yet</p>
            <p className="mt-1 text-sm text-text-muted">Ask selected families to rank a few possible class times.</p>
          </div>
          <Button leftIcon={<Plus />} onClick={onCreate}>New time poll</Button>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-3">
      {polls.map((poll) => (
        <button
          key={poll.pollId}
          type="button"
          onClick={() => onOpen(poll)}
          className="flex w-full items-center justify-between gap-4 rounded-lg border border-border bg-surface p-4 text-left transition-colors hover:border-primary/40 hover:bg-surface-elevated"
        >
          <div className="min-w-0">
            <div className="flex flex-wrap items-center gap-2">
              <p className="truncate font-semibold text-text">{poll.title}</p>
              <span className={`rounded-full border px-2 py-0.5 text-xs font-semibold ${statusStyle[poll.status]}`}>{poll.status.charAt(0) + poll.status.slice(1).toLowerCase()}</span>
            </div>
            <p className="mt-1 text-sm text-text-muted">{poll.programName} · {poll.slots.length} options · {poll.respondedCount} of {poll.athleteCount} replied</p>
          </div>
          <ArrowRight className="h-4 w-4 shrink-0 text-text-muted" />
        </button>
      ))}
    </div>
  );
}
